import { render } from "./WalletInformation.vue?vue&type=template&id=b8a209a2"
import script from "./WalletInformation.vue?vue&type=script&lang=js"
export * from "./WalletInformation.vue?vue&type=script&lang=js"

import "./WalletInformation.vue?vue&type=style&index=0&id=b8a209a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__